export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_02.59c4ab85.jpg";